// extracted by mini-css-extract-plugin
export var accolades = "patti-module--accolades--+bgxH";
export var intro = "patti-module--intro--CQgJO";
export var patti = "patti-module--patti--aazRz";